// eslint-disable-next-line
const escapeStringRegexp = require("escape-string-regexp");

// eslint-disable-next-line
const pagePath = `content`;
const indexName = `Pages`;

const pageQuery = `{
  stories: allStoryblokEntry(
    filter: { field_component: { in: ["magazine", "news_and_opinion", "book_review", "podcast", "webinar", "downloads", "training_course", "newsletter", "magazine_issue", "event"] } }
  ) {
    edges {
      node {
        id
        name
        slug
        field_component
        full_slug
        content
        tag_list
        first_published_at
      }
    }
  }
}`;

function pageToAlgoliaRecord({ node: { id, content, ...rest } }) {
  const body = JSON.parse(content)
  return {
    objectID: id,
    ...body,
    ...rest,
  };
}

const queries = [
  {
    query: pageQuery,
    transformer: ({ data }) => data.stories.edges.map(pageToAlgoliaRecord),
    indexName
  },
];

module.exports = queries;
